import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from 'rc-tooltip';

// Explains a term that plain-language copy deliberately left out, without putting the jargon
// back in the sentence.
//
// A <button> rather than a <span title>: natively focusable, so the tooltip is reachable
// without a mouse (trigger includes 'focus'). rc-tooltip only mounts its overlay while shown,
// so the definition ALSO lives in a permanent visually-hidden sibling — that is the path
// assistive tech actually takes, and it lets specs assert the copy without simulating hover.
//
// The sibling deliberately carries no aria-describedby from the trigger: rc-tooltip clones its
// child and sets aria-describedby to its own overlay id unconditionally (verified — it
// overwrites ours whether or not `id` is passed), so any reference we add is silently
// discarded. The hidden sibling is read in document order immediately after the button
// instead. Wiring it properly would mean replacing rc-tooltip, which is a bigger change than
// this page.
const JargonTooltip = ({ term, text, id }) => (
  <>
    <Tooltip id={id} overlay={text} placement="top" trigger={['hover', 'focus']}>
      <button type="button" className="od-tip" aria-label={`What this means: ${term}`}>
        ?
      </button>
    </Tooltip>
    <span className="sr-only" id={`${id}-definition`}>
      {text}
    </span>
  </>
);

JargonTooltip.propTypes = {
  term: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default JargonTooltip;
